import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { closeParticipantModel, exportPollParticipants } from "../../store/slices/pollSlice";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import PersonIcon from '@mui/icons-material/Person';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';


const getModalContent = (modelType) => {
    switch (modelType) {
        case 'Contest':
            return (
                <>
                    <svg viewBox="0 0 24 24" className="status-icon">
                        <circle cx="12" cy="12" r="12" fill="#4A90E2"></circle>
                        <path
                            fill="white"
                            d="M17.9 9.7v-.8h-2.1c0 1.2-.2 2.2-.6 3.1.8-.2 1.4-.5 2-.9.4-.5.7-1 .7-1.4 0 0 0 .4 0 0zm-9 2.3c-.4-.9-.6-1.9-.6-3.1H6.1v.8c0 .4.3.9.8 1.4.5.4 1.2.7 2 .9 0 0-.8-.2 0 0zM19 8.6v1.1c0 .4-.1.8-.3 1.2-.2.4-.5.8-.9 1.1-.4.3-.9.6-1.5.8-.6.2-1.2.3-1.8.4-.2.3-.5.6-.8.8-.2.2-.4.4-.4.6-.1.2-.1.5-.1.7 0 .3.1.6.3.8.2.2.4.3.8.3s.8.1 1.1.4c.3.3.5.6.5 1v.5c0 .1 0 .1-.1.2s-.1.1-.2.1h-7c-.1 0-.1 0-.2-.1s-.1-.1-.1-.2v-.5c0-.4.2-.7.5-1 .3-.3.7-.4 1.1-.4.4 0 .6-.1.8-.3.2-.2.3-.5.3-.8 0-.3 0-.5-.1-.7s-.2-.4-.4-.6c-.3-.2-.6-.5-.8-.8-.6 0-1.2-.2-1.8-.4-.6-.2-1.1-.5-1.5-.8-.4-.3-.7-.7-.9-1.1-.4-.4-.5-.8-.5-1.2V8.6c0-.2.1-.4.2-.6.2-.2.3-.2.6-.2h2.4V7c0-.4.1-.7.4-.9.3-.3.6-.4.9-.4h4.8c.4 0 .7.1.9.4.3.3.4.6.4.9v.8H18c.2 0 .4.1.6.2.3.2.4.4.4.6 0 0 0-.2 0 0z"
                        ></path>
                    </svg>
                    <div className="px-4 h4 mb-0">Contest Participants</div>
                </>
            );
        default:
            return (
                <>
                    <svg viewBox="0 0 24 24" className="status-icon">
                        <circle cx="12" cy="12" r="12" fill="#4A90E2"></circle>
                        <path
                            fill="white"
                            d="M4.5 6.6h6.9v2.9H4.5V6.6zm0 7.4h14.8v-3H4.5v3zm0 4.4h10.8v-2.9H4.5v2.9z"
                        ></path>
                    </svg>
                    <div className="px-4 h4 mb-0">Poll Participants</div>
                </>
            );
    }
};

const ParticipantModel = ({ show, modelType = 'Polls' }) => {
    const dispatch = useDispatch();
    const { pollId } = useSelector((state) => state.poll);
    const [isLoading, setIsLoading] = useState(false);
    const [participants, setParticipants] = useState([]);
    const [open, setOpen] = useState('');

    const toggle = (id) => {
        setOpen(open === id ? '' : id);
    };

    const hideModel = () => dispatch(closeParticipantModel());

    useEffect(() => {
        if (pollId) {
            setIsLoading(true);
            dispatch(exportPollParticipants({ id: pollId }))
                .unwrap()
                .then((res) => {
                    setParticipants(res || []);
                    setIsLoading(false);
                })
                .catch(() => setIsLoading(false));
        }
    }, [pollId, dispatch]);



    return (
        <Modal show={show} size="lg" backdrop="static" keyboard={false} >
            <div className="status-box p-3">
                {getModalContent(modelType)}
            </div>

            <div className="p-3 position-relative" style={{ minHeight: '300px' }}>
                {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{
                        position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(255, 255, 255, 0.7)", zIndex: 9999
                    }}>
                        <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <Accordion open={open} toggle={toggle}>
                        {participants.map((participant, index) => {
                            const explodedName = participant.name?.split(' ') || [];
                            let initials = `${explodedName[0]?.charAt(0) || ''}${explodedName[1]?.charAt(0) || ''}`.toUpperCase();

                            if (participant.avatar) {
                                initials = <img className="avatar w-100" src={participant.avatar} alt="avatar" />;
                            }

                            const facebookInfo = participant.extraInfo?.facebook;

                            return (
                                <AccordionItem key={index}>
                                    <AccordionHeader targetId={index.toString()} className="custom-header">
                                        <div className="namedLogo rounded-circle overflow-hidden">{initials}</div>
                                        <span className="text-capitalize">
                                            {facebookInfo?.displayName || participant.name || participant.extraInfo.firstName + ' ' + participant.extraInfo.lastName}
                                        </span>

                                    </AccordionHeader>

                                    <AccordionBody accordionId={index.toString()}>
                                        <table className="table mb-0">
                                            <tbody>
                                                {facebookInfo ? (
                                                    <>
                                                        <tr className="border-bottom">
                                                            <td className="text-center" style={{ width: '50px' }}>
                                                                <EmailIcon />
                                                            </td>
                                                            <td>{facebookInfo.email}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center">
                                                                <FacebookIcon
                                                                    onClick={() => {
                                                                        window.open(`https://www.facebook.com/${facebookInfo.id}`, '_blank');
                                                                    }}
                                                                    style={{ cursor: "pointer", color: "#3B5998" }}
                                                                />
                                                            </td>
                                                            <td>Facebook Profile</td>
                                                        </tr>
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td className="text-center" style={{ width: '50px' }}>
                                                            <LocalPhoneIcon />
                                                        </td>
                                                        <td>{participant.userId}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </AccordionBody>

                                </AccordionItem>
                            );
                        })}
                    </Accordion>
                )}
            </div>

            <div className="text-right p-3">
                <div className="button-div">
                    <button type="button" className="btn btn-outline-danger mx-3" onClick={hideModel}>
                        Close
                    </button>
                </div>
            </div>
        </Modal >
    );
};

export default ParticipantModel;
